export default __webpack_public_path__ + "media/avatars/07-efaa69a2.png";